export default "__VITE_ASSET__BDmp4cjv__"